<template>
  <b-card>
    <b-row class="position-relative">
      <b-col
        md="12"
      >
        <validation-observer ref="validCustomerRules">
          <b-form>
            <b-row>
              <b-col md="6">
                <InputField
                  id="valid-customer-id"
                  v-model="validCustomerIdSearchParams.customerID"
                  :label="$t('Valid Customer ID')"
                  :placeholder="$t('Enter valid customer ID')"
                  rules="required"
                  :error-name="$t('Customer ID')"
                  type="text"
                />
              </b-col>

              <b-col md="2">
                <Button
                  :label="$t('Search')"
                  size="md"
                  class="mt-2"
                  block
                  @click="handleValidCustomerIDSearch"
                />
              </b-col>
            </b-row>

          </b-form>
        </validation-observer>
        <div v-if="isValidCustomer">
          <app-collapse
            class="business-items mb-4"
            type="margin"
            accordion
          >
            <app-collapse-item
              :title="$t('Customer Information')"
              class="card-item"
              is-visible
            >
              <b-row>
                <b-col md="4">
                  <InputField
                    id="customer-name"
                    v-model="validCustomerData.name"
                    :label="$t('Customer Name')"
                    type="text"
                    readonly
                  />
                </b-col>
                <b-col md="4">
                  <InputField
                    id="customer-type"
                    v-model="validCustomerData.customerType"
                    :label="$t('Customer Type')"
                    type="text"
                    readonly
                  />
                </b-col>
                <b-col md="4">
                  <InputField
                    id="bvn"
                    v-model="validCustomerData.bvn"
                    :label="$t('BVN')"
                    type="text"
                    readonly
                  />
                </b-col>
                <b-col md="4">
                  <InputField
                    id="phone-number"
                    v-model="validCustomerData.phoneNumber"
                    :label="$t('Phone Number')"
                    type="text"
                    readonly
                  />
                </b-col>
                <b-col md="4">
                  <InputField
                    id="email"
                    v-model="validCustomerData.email"
                    :label="$t('Email Address')"
                    type="text"
                    readonly
                  />
                </b-col>
                <b-col md="4">
                  <InputField
                    id="date-of-birth"
                    v-model="validCustomerData.dateOfBirth"
                    :label="$t('Date of Birth')"
                    type="text"
                    readonly
                  />
                </b-col>
                <b-col md="4">
                  <InputField
                    id="nationality"
                    v-model="validCustomerData.nationality"
                    :label="$t('Nationality')"
                    type="text"
                    readonly
                  />
                </b-col>
                <b-col md="4">
                  <InputField
                    id="State"
                    v-model="validCustomerData.state"
                    :label="$t('State')"
                    type="text"
                    readonly
                  />
                </b-col>
                <b-col md="4">
                  <InputField
                    id="hometown"
                    v-model="validCustomerData.hometown"
                    :label="$t('Hometown')"
                    type="text"
                    readonly
                  />
                </b-col>

              </b-row>
            </app-collapse-item>
          </app-collapse>
        </div>
        <div v-if="isValidCustomer">
          <validation-observer ref="invalidCustomerRules">
            <b-form>
              <b-row>
                <b-col md="6">
                  <InputField
                    id="invalid-customer-id"
                    v-model="invalidCustomerIdSearchParams.customerID"
                    :label="$t('Invalid Customer ID')"
                    :placeholder="$t('Enter invalid customer ID')"
                    rules="required"
                    type="text"
                  />
                </b-col>

                <b-col md="2">
                  <Button
                    :label="$t('Search')"
                    size="md"
                    class="mt-2"
                    block
                    @click="handleInvalidCustomerIDSearch"
                  />
                </b-col>
              </b-row>
            </b-form>
          </validation-observer>
        </div>
        <!-- isValidCustomer -->
        <div v-if="isInvalidCustomer">
          <app-collapse
            class="business-items mb-4"
            type="margin"
            accordion
          >
            <app-collapse-item
              :title="$t('Customer Information')"
              class="card-item"
              is-visible
            >
              <b-row>
                <b-col md="4">
                  <InputField
                    id="customer-name"
                    v-model="invalidCustomerData.name"
                    :label="$t('Customer Name')"
                    type="text"
                    readonly
                  />
                </b-col>
                <b-col md="4">
                  <InputField
                    id="customer-type"
                    v-model="invalidCustomerData.customerType"
                    :label="$t('Customer Type')"
                    type="text"
                    readonly
                  />
                </b-col>
                <b-col md="4">
                  <InputField
                    id="bvn"
                    v-model="invalidCustomerData.bvn"
                    :label="$t('BVN')"
                    type="text"
                    readonly
                  />
                </b-col>
                <b-col md="4">
                  <InputField
                    id="phone-number"
                    v-model="invalidCustomerData.phoneNumber"
                    :label="$t('Phone Number')"
                    type="text"
                    readonly
                  />
                </b-col>
                <b-col md="4">
                  <InputField
                    id="email"
                    v-model="invalidCustomerData.email"
                    :label="$t('Email Address')"
                    type="text"
                    readonly
                  />
                </b-col>
                <b-col md="4">
                  <TextAreaField
                    id="address"
                    v-model="invalidCustomerData.address"
                    rows="2"
                    :placeholder="$t('Customer Address')"
                    :label="$t('Customer Address')"
                    type="text"
                    readonly
                  />
                </b-col>
              </b-row>
              <b-row
                v-for="(item, index) in customerAccountList"
                :key="index"
              >
                <b-col md="12">
                  <h5 class="section-label mb-0 mt-1">
                    {{ $t('Customer Account') }} {{ `${index + 1 }` }}
                  </h5>
                </b-col>
                <b-col md="3">
                  <InputField
                    id="account-number"
                    v-model="item.accountNumber"
                    :label="$t('Account Number')"
                    type="text"
                    readonly
                  />
                </b-col>
                <b-col md="3">
                  <SelectField
                    id="product-name"
                    v-model="item.productCode"
                    :label="$t('Product Name')"
                    :options="productOptions"
                    :reduce="option => option.value"
                    item="label"
                    :placeholder="$t('Select')"
                    readonly
                  />
                </b-col>
                <b-col md="3">
                  <InputField
                    id="account-type"
                    v-model="item.accountType"
                    :label="$t('Account Type')"
                    type="text"
                    readonly
                  />
                </b-col>
                <b-col md="3">
                  <InputField
                    id="available-balance"
                    v-model="item.availableBalance"
                    :label="$t('Available Balance')"
                    type="text"
                    readonly
                  />
                </b-col>
              </b-row>
            </app-collapse-item>
          </app-collapse>
        </div>

        <div
          v-if="isValidCustomer && isInvalidCustomer"
          class="text-center mt-5"
        >
          <Button
            :label="$t('Relink Customer')"
            :loading="isLoading"
            :disabled="isDisabled"
            size="lg"
            @click="handleSubmit"
          />
        </div>

      </b-col>
    </b-row>

    <FullScreenSpinner :show="showSpinner" />
  </b-card>
</template>

<script>

import {
  BCard, BRow, BCol, BForm,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { heightFade } from '@core/directives/animations'
import { required, positive } from '@validations'
import { ValidationObserver } from 'vee-validate'
import { sweetAlert } from '@core/mixins/sweetAlert'
import { tableMixins } from '@core/mixins/table'
import { mapActions } from 'vuex'
import { modalMixins } from '@core/mixins/modal'
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
import FullScreenSpinner from '@/views/components/spinner/FullScreenSpinner.vue'
import InputField from '../../../forms/InputField.vue'
import SelectField from '../../../forms/SelectField.vue'
import TextAreaField from '../../../forms/TextAreaField.vue'
import Button from '../../../components/button/Button.vue'
import { toBalance } from '../../../../helpers/formatAmount'
import { toDateWithYear, toYearWithDate } from '../../../../helpers/formatDate'

export default {
  components: {
    BRow,
    BCol,
    BForm,
    InputField,
    SelectField,
    TextAreaField,
    Button,
    BCard,
    FullScreenSpinner,
    ValidationObserver,
    AppCollapse,
    AppCollapseItem,
  },
  directives: {
    Ripple,
    'height-fade': heightFade,
  },
  mixins: [sweetAlert, tableMixins, modalMixins],
  data() {
    return {
      validCustomerID: false,
      isValidCustomer: false,
      isInvalidCustomer: false,
      isLoading: false,
      isDisabled: false,
      required,
      positive,
      showSpinner: false,
      validCustomerIdSearchParams: {
        customerID: null,
      },
      invalidCustomerIdSearchParams: {
        customerID: null,
      },
      validCustomerData: {
        customerID: '',
        customerType: '',
        bvn: '',
        name: '',
        hometown: '',
        state: '',
        nationality: '',
        dateOfBirth: '',
        email: '',
        phoneNumber: '',
        maritalStatus: '',
        address: '',
      },
      invalidCustomerData: {
        customerID: '',
        customerType: '',
        bvn: '',
        name: '',
        hometown: '',
        state: '',
        nationality: '',
        dateOfBirth: '',
        email: '',
        phoneNumber: '',
        maritalStatus: '',
        address: '',
      },
      customerAccountList: [],
      productOptions: [],
    }
  },
  async mounted() {
    await this.fetchProducts()
  },
  methods: {
    ...mapActions({
      searchCustomerInformation: 'account/searchCustomerInformationAction',
      getAccountDetailsByCustomerID: 'account/getAccountDetailsByCustomerID',
      performCustomerRelink: 'account/performCustomerRelinkAction',
      getProducts: 'account/getProducts',
    }),
    async handleValidCustomerIDSearch() {
      this.$refs.validCustomerRules.validate().then(async success => {
        if (success) {
          try {
            this.showSpinner = true
            const { customerID } = this.validCustomerIdSearchParams

            const response = await this.searchCustomerInformation({ customerID, permission: 'RELINK_CUSTOMER' })
            const { status, data } = response
            if (status === 200 && data.data) {
              this.validCustomerData = {
                customerID: data.data.customerID,
                customerType: data.data.customerType,
                bvn: data.data.bvn,
                name: data.data.name,
                hometown: data.data.hometown,
                state: data.data.state,
                nationality: data.data.nationality,
                dateOfBirth: data.data.dateOfBirth ? toDateWithYear(data.data.dateOfBirth) : null,
                email: data.data.email,
                phoneNumber: data.data.phoneNumber,
                maritalStatus: data.data.maritalStatus,
                address: data.data.address,
              }
              this.isValidCustomer = true
            }
            this.showSpinner = true
          } catch (error) {
            this.handleError(error)
          } finally {
            this.showSpinner = false
          }
        }
      })
    },
    async fetchProducts() {
      try {
        const response = await this.getProducts({
          search: '',
          page: 0,
          limit: 0,
          permission: 'RELINK_CUSTOMER',
        })
        const { status, data } = response
        if (status === 200 && data.data) {
          this.productOptions = data.data.filter(item => item.type === 'Savings' && item.status === 'Active').map(item => ({ label: item.name, value: item.code.toString() }))
        }
      } catch (error) {
        this.alertError({ text: error })
      }
    },
    async handleInvalidCustomerIDSearch() {
      this.$refs.invalidCustomerRules.validate().then(async success => {
        if (success) {
          try {
            this.showSpinner = true
            const { customerID } = this.invalidCustomerIdSearchParams

            const response = await this.searchCustomerInformation({ customerID, permission: 'RELINK_CUSTOMER' })
            const accountResponse = await this.getAccountDetailsByCustomerID({ customerID, permission: 'RELINK_CUSTOMER' })
            const { status, data } = response
            if (status === 200 && data.data) {
              this.invalidCustomerData = {
                customerID: data.data.customerID,
                customerType: data.data.customerType,
                name: data.data.name,
                bvn: data.data.bvn,
                hometown: data.data.hometown,
                state: data.data.state,
                nationality: data.data.nationality,
                dateOfBirth: data.data.dateOfBirth ? toDateWithYear(data.data.dateOfBirth) : null,
                email: data.data.email,
                phoneNumber: data.data.phoneNumber,
                maritalStatus: data.data.maritalStatus,
                address: data.data.address,
              }
              this.isInvalidCustomer = true
            }
            if (accountResponse.data.data.length) {
              this.customerAccountList = accountResponse.data.data ? accountResponse.data.data.map(item => ({
                accountNumber: item.accountNumber,
                accountType: item.accountType,
                productCode: item.productCode,
                availableBalance: toBalance(item.availableBalance),
              })) : []
            }

            this.showSpinner = true
          } catch (error) {
            this.handleError(error)
          } finally {
            this.showSpinner = false
          }
        }
      })
    },
    async handleSubmit() {
      const text1 = this.$t('You are about to merge invalid Customer ID')
      const text2 = this.$t('with valid Customer ID')
      const text3 = this.$t('Customer ID')
      const text4 = this.$t('will no longer exist on the system and this action')
      const text5 = this.$t('CAN NOT')
      const text6 = this.$t('be restored. Are you sure you want to proceed?')
      this.confirm(this.relinkCustomers, { text: `${text1} ${this.invalidCustomerData.customerID} ${text2} ${this.validCustomerData.customerID}. ${text3} ${this.invalidCustomerData.customerID} ${text4} <span style="color: red; font-weight: bold;">${text5}</span> ${text6}` })
    },
    async relinkCustomers() {
      try {
        this.isLoading = true
        this.isDisabled = true
        const formData = {
          ...this.validCustomerData,
          dateOfBirth: this.validCustomerData.dateOfBirth ? toYearWithDate(this.validCustomerData.dateOfBirth) : null,
          validCustomerID: this.validCustomerIdSearchParams.customerID,
          invalidCustomerID: this.invalidCustomerIdSearchParams.customerID,

        }
        const response = await this.performCustomerRelink({ formData, permission: 'RELINK_CUSTOMER' })

        const { status } = response
        if (status === 200) {
          this.isValidCustomer = false
          this.isInvalidCustomer = false
          this.isLoading = false
          this.isDisabled = false
          this.resetInputField()
          this.alertSuccess({ text: this.$t('Your Customer Relink request was successful') })
        }
      } catch (error) {
        this.handleError(error)
      } finally {
        this.isLoading = false
        this.isDisabled = false
        this.isValidCustomer = false
        this.isInvalidCustomer = false
      }
    },
    resetInputField() {
      this.validCustomerIdSearchParams = { ...null }
      this.invalidCustomerIdSearchParams = { ...null }
      this.validCustomerData = { ...null }
      this.invalidCustomerData = { ...null }
      this.isValidCustomer = false
      this.validCustomerID = false
    },
  },
}
</script>
<style scoped>
 [dir] .demo-inline-spacing > *, .custom-control , .custom-control-inline, .custom-checkbox {
    margin-top: 0rem !important;
}
.card-item {
  border: 1px solid #d8d6de !important;
  border-radius: 0.358rem
}
</style>
